jQuery($ => {

  if ( $('.o-before-after-showcase')[0] ) {
    var $before = $(".o-before-after-showcase__device--before .m-browser__window");
    var $after  = $(".o-before-after-showcase__device--after .m-browser__window");
    
    $before.on('scroll', function () {
      const $showcase = $(this).closest('.o-before-after-showcase');
      const $sibling  = $showcase.find('.o-before-after-showcase__device--after .m-browser__window');

      $sibling.scrollTop($(this).scrollTop());
    });
  
    $after.on('scroll', function () {
      const $showcase = $(this).closest('.o-before-after-showcase');
      const $sibling  = $showcase.find('.o-before-after-showcase__device--before .m-browser__window');

      $sibling.scrollTop($(this).scrollTop());
    });
  }

});